.after-submission-container {
    background-color: var(--off-white);
    height: 100%;
}
